import React from 'react';


const rgpd = () => {

        return(
            <div className="container col-12 mt-6">
                <h2>Proteção de dados</h2>

                <p>
                    A presente política de privacidade abrange o Sistema de Informação do E-cuidHaMUs, regendo-se pelo Regulamento Geral de Proteção de Dados (RGPD), Regulamento (UE) n.º 2016/679, de 27 de abril de 2016.
                </p>

                <h4>Dados pessoais</h4>

                <p>
                    O E-cuidHaMUs respeita a sua privacidade enquanto utilizador deste sistema de informação, garantindo a segurança e a confidencialidade sobre todos os dados pessoais que necessite de partilhar com a instituição por esta via, não recolhendo qualquer informação pessoal sobre si sem o seu consentimento, nos termos exigidos pelo RGPD.

                    Os dados recolhidos nos formulários do Sistema de Informação do E-cuidHaMUs destinam-se exclusivamente ao processamento dos pedidos dos utilizadores, e não serão usados para qualquer outro fim, salvaguardando-se sempre a sua confidencialidade, nos termos da proteção conferida pelo referido Regulamento.

                    O tratamento destes dados é da responsabilidade do E-cuidHaMUs e o seu armazenamento é efetuado em sistemas de informação próprios, que se encontram devidamente protegidos. A informação recolhida poderá apenas ser acedida e tratada pelos trabalhadores do E-cuidHaMUs no âmbito das suas funções, estando sempre claro nos respetivos formulários de recolha os fins a que se destinam. As restantes questões a considerar nesta matéria serão tratadas pelo E-cuidHaMUs de acordo com o regime estabelecido pelo RGPD.
                </p>

                <h4>Declaração sobre Direitos de Autor</h4>

                <p>
                    Todos os conteúdos de qualquer natureza constantes no Sistema de informação do E-cuidHaMUs estão protegidos por Lei, sendo expressamente interdita qualquer cópia, reprodução, difusão, transmissão, utilização, modificação, venda, publicação, distribuição ou quaisquer outras utilizações, por quaisquer meios, à exceção das previstas na Lei.

                    Para a realização de citações e menção da fonte, deverá utilizar-se uma notação que identifique o E-cuidHaMUs e o endereço Web dos conteúdos específicos consultados, com indicação das datas de consulta e de atualização (constante no sítio) dos mesmos conteúdos.
                </p>

                <h4>Exoneração de responsabilidade no âmbito das Webs sociais</h4>

                <p>
                    O E-cuidHaMUs encara a participação dos membros da sua comunidade nas webs sociais como forma de promoção de interações entre a comunidade da Universidade e a vasta comunidade de públicos com a qual partilha interesses. Contudo, o E-cuidHaMUs não pode responsabilizar-se pelos conteúdos aí colocados, que são da exclusiva responsabilidade dos seus promotores.
                </p>

                <h4>O Encarregado da Proteção de Dados</h4>

                <p>
                    O E-cuidHaMUs tem um Encarregado de Proteção de Dados (EPD) / Data Protection Officer (DPO), que garante a conformidade do tratamento de dados pessoais com a legislação em vigor, estando disponível através do endereço de correio eletrónico epd@ua.pt.
                </p>

                <h4>Recolha e utilização de informação técnica</h4>

                <p>
                    O Sistema de informação do E-cuidHaMUs usa cookies, estando definindo o seu âmbito na política de cookies.

                    Apenas são registadas, nos nossos servidores, informações técnicas relativas às visitas ao Sistema de informação do E-cuidHaMUs, não sendo recolhida informação que possa ser usada para identificar os visitantes do sítio. A informação técnica registada limita-se aos seguintes itens:

                    o endereço de IP (Internet Protocol) do visitante;
                    o tipo de navegador de Internet (browser) utilizado pelo visitante do site e o respetivo sistema operativo usado;
                    a data e a hora da consulta;
                    as páginas visitadas no site e os documentos descarregados.
                    A informação técnica será utilizada apenas para finalidades estatísticas.
                </p>

                <h4>Política de cookies</h4>
                <p>
                    Os cookies são pequenos ficheiros com informação alfanumérica gravados no disco rígido do seu computador pelo navegador. Estes ficheiros são necessários para que o servidor consiga distinguir cada utilizador e manter o estado durante a navegação de um utilizador.

                    Os cookies usados no Sistema de informação do E-cuidHaMUs são anónimos, não sendo guardada neles qualquer informação pessoal dos nossos utilizadores, nem outra informação que os permita identificar pessoalmente. Os nossos cookies são usados para melhorar a experiência dos nossos utilizadores e para nos permitir analisar a utilização do site de forma a otimizarmos as funcionalidades nele existentes.
                </p>

                <p>
                    No Sistema de informação do E-cuidHaMUs são utilizados:
                </p>

                <p>
                    Cookies de sessão - para registar preferências do utilizador como a língua em que os sites devem ser apresentados e para manter as sessões de utilizadores autenticados. Os cookies deste tipo são automaticamente apagados quando o navegador é fechado.
                </p>

                <p>
                    Cookies persistentes - para guardar informação necessária entre sessões. Por exemplo, é guardado um cookie deste tipo para indicar que o utilizador tomou conhecimento da política de cookies e para esconder a mensagem relativa a esta. Este tipo de cookies mantém-se no computador até chegar a sua data de expiração ou serem apagados pelo utilizador.
                </p>
                <p>
                    Este portal utiliza o serviço Analytics disponibilizado pelo Google para melhorar o desempenho do site registando informação genérica dos acessos recebidos usando cookies anónimos para este fim.
                </p>

                <h3>Termos de utilização</h3>

                <p>
                    Os textos, conteúdos e imagens publicados neste portal são propriedade do E-cuidHaMUs, não podendo ser reproduzidos ou modificados sem prévia autorização expressa desta, exceto em casos de utilização livre, designadamente para fins de ensino ou investigação ou para uso pessoal, devendo, nestes casos, indicar-se a titularidade dos mesmos.
                </p>

                <h4>Exoneração de responsabilidade</h4>

                <p>
                    O E-cuidHaMUs não se responsabiliza por eventuais incorreções na informação ou documentação existente neste portal nem pelo conteúdo das páginas para as quais remetem os links ou hiperlinks dele constantes.
                </p>

                <h4>Legislação aplicável</h4>

                <p>
                    O presente portal é regulado pela legislação pertinente, nomeadamente pelo Código dos Direitos de Autor e dos Direitos Conexos e pelo Código da Propriedade Industrial.

                    Ao usar o portal do E-cuidHaMUs, o utilizador aceita os termos e condições do mesmo.
                </p>
            </div>
        )
};
export default rgpd;



// WEBPACK FOOTER //
// ./src/components/rgpd.js